import {RequestModel} from "../../../request";
import {REQUEST} from "../../../requests.consts";
import {shareState} from "../../../../../app/share-state";

export class GetRequestSearchPlayersModel extends RequestModel {
  constructor(requestParams) {
    super(REQUEST.CATEGORY.tournament, REQUEST.ACTION.TOURNAMENT.searchPlayers, requestParams, false, true, false, false);

    this.apiEnvironment = shareState.environment.baseUrl;
    this.method = REQUEST.METHOD_TYPE.get;
  }
}
